import { Lesson } from '@/types/lesson';
import { User } from '@/types/user';
import { api } from './index';
import { Methods } from './interfaces';
import { IGetTeachersReq } from './models';

type UpdateLessonReq = Omit<
  Lesson,
  'isTrial' | 'isAdvance' | 'studentEmail' | 'history'
>;

const updateLesson = (options: UpdateLessonReq): Promise<Lesson> => {
  return api<UpdateLessonReq, Lesson>({
    method: Methods.POST,
    route: '/lesson/update',
    payload: options,
  });
};

interface GetByIdRes {
  lesson: Lesson;
  userInfo: {
    lessonBalance: number;
    lessonCompleted: number;
    children: {
      name: string;
      realname: string;
      age: string;
    }[];
  };
}

const getOnboardingInfo = (id: string) => {
  return api<{ id: string }, GetByIdRes>({
    method: Methods.GET,
    route: `/lesson/onboarding_info_by_id`,
    payload: { id },
  });
};

const getById = (id: string) => {
  return api<{ id: string }, GetByIdRes>({
    method: Methods.GET,
    route: '/lesson/get_by_id',
    payload: { id },
  });
};

interface GetLessonsReq {
  page?: number;
  limit?: number;
  filters?: {
    id?: string;
    teacher?: string;
    student?: string;
    start?: string;
  };
}

interface GetLessonsRes {
  lessons: Lesson[];
  total: number;
  totalWithFilters: number;
}

const getLessons = (options: GetLessonsReq) => {
  return api<GetLessonsReq, GetLessonsRes>({
    method: Methods.GET,
    route: '/lesson',
    payload: options,
  });
};

const getTeachers = (payload: IGetTeachersReq) => {
  return api<IGetTeachersReq, any>({
    method: Methods.GET,
    route: '/lesson/teachers',
    payload,
  });
};

const sendInstruction = (payload: { lessonId: string }) =>
  api<{ lessonId: string }, { isInstructionSend: boolean }>({
    method: Methods.POST,
    route: '/lesson/send_instruction',
    payload,
  });

const chargeForSkippedLesson = (id: string) =>
  api<{ id: string }, void>({
    method: Methods.POST,
    route: '/lesson/chargeForSkippedLesson',
    payload: { id },
  });

const resetStudentPassword = (id: string) =>
  api<{ id: string }, void>({
    method: Methods.POST,
    route: '/lesson/resetStudentPassword',
    payload: { id },
  });

export const lessonApi = {
  updateLesson,
  getOnboardingInfo,
  getById,
  getLessons,
  getTeachers,
  sendInstruction,
  chargeForSkippedLesson,
  resetStudentPassword,
};
